const updates = [
  {
    date: '2026-07-31',
    title: '《奔跑吧》第十二季第十期上线',
    desc: '本期迎来神秘飞行嘉宾，全新游戏环节爆笑不断，全员集结上演年度最精彩撕名牌大战。',
  },
  {
    date: '2026-07-30',
    title: '《乘风2024》第五次公演舞台完整版',
    desc: '姐姐们突破极限挑战全新曲风，舞台视觉效果全面升级，神仙打架级别的精彩表演。',
  },
  {
    date: '2026-07-30',
    title: '《王牌对王牌》第八季喜剧之夜特辑',
    desc: '沈腾贾玲再度同台飙戏，经典游戏全新改版，全场笑点密集停不下来。',
  },
  {
    date: '2026-07-29',
    title: '《这就是街舞7》半决赛直播回放',
    desc: '四位队长带队激烈角逐，炸裂齐舞与神仙Battle轮番上演，每一帧都是视觉盛宴。',
  },
  {
    date: '2026-07-29',
    title: '平台功能升级：智能推荐算法上线',
    desc: '全新个性化推荐系统正式启用，根据你的观看偏好精准推荐你可能喜欢的综艺节目。',
  },
  {
    date: '2026-07-28',
    title: '《密室大逃脱》第五季古堡谜案特辑',
    desc: '全新古堡主题密室挑战，烧脑谜题层层递进，紧张氛围拉满的沉浸式逃脱体验。',
  },
  {
    date: '2026-07-28',
    title: '《向往的生活》海岛篇本周更新',
    desc: '蘑菇屋迎来新朋友，海边落日烧烤派对温馨治愈，慢综艺天花板再创名场面。',
  },
  {
    date: '2026-07-27',
    title: '《天赐的声音》第五季巅峰之夜',
    desc: '音乐合伙人强强联手演绎经典金曲，天籁之音震撼心灵，年度最佳音乐舞台诞生。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              最新动态
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              综艺更新快讯
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              实时追踪最新综艺上线动态，不错过任何精彩内容
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
              {updates.map((item, idx) => (
                <div key={idx} className={`relative ${idx < updates.length - 1 ? 'mb-8 md:mb-10' : ''}`}>
                  <div className="absolute -left-[calc(2rem+5px)] md:-left-[calc(2.5rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 border-4 border-background-50"></div>
                  <div className="bg-background-50 border border-background-200 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all cursor-pointer">
                    <span className="text-xs text-primary-500 font-semibold mb-1 block whitespace-nowrap">
                      <i className="ri-time-line mr-1"></i>{item.date}
                    </span>
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}